import DOMPurify from "dompurify";

/**
 * Sanitizes HTML before rendering to prevent XSS attacks.
 */
export const sanitizeHtml = (html = "") => {
  if (!html || typeof html !== "string") return "";

  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
  });
};

/**
 * Helper function for dangerouslySetInnerHTML
 */
export const renderHtml = (html = "") => {
  return {
    __html: sanitizeHtml(html),
  };
};